import React from 'react';
import { Navigate, Route } from 'react-router-dom';

import { UserRolesEnum } from 'commons/types/user.roles.enum';
import PrivateRoute from 'commons/utils/privateRoute';
import DNDetailPage from 'pages/delivery-note/dn-detail/DNDetailPage';
import DNListPage from 'pages/delivery-note/dn-list/DNListPage';

import {
  DELIVERY_NOTE_ROUTE_ROOT,
  DELIVERY_NOTE_ROUTES,
} from './constants/delivery-note-routes.constant';

export const useDeliveryNoteRouter = (): React.JSX.Element => (
  <Route
    path={DELIVERY_NOTE_ROUTE_ROOT}
    element={
      <PrivateRoute
        roles={[
          UserRolesEnum.ADMIN,
          UserRolesEnum.SUPER_ADMIN,
          UserRolesEnum.PACKER,
          UserRolesEnum.PACKER_LEAD,
          UserRolesEnum.PACKER_SPV,
        ]}
      />
    }
  >
    <Route path={DELIVERY_NOTE_ROUTES.LIST} element={<DNListPage />} />
    <Route path={DELIVERY_NOTE_ROUTES.DETAIL} element={<DNDetailPage />} />
    <Route
      path={DELIVERY_NOTE_ROUTES.DELIVERY_NOTE}
      element={<Navigate to={DELIVERY_NOTE_ROUTES.LIST} />}
    />
    <Route path={DELIVERY_NOTE_ROUTES.WILDCARD} element={<Navigate to="/" />} />
  </Route>
);
